
/**
 * 상품 타입
 */
export type GetOrderById200ItemType = typeof GetOrderById200ItemType[keyof typeof GetOrderById200ItemType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetOrderById200ItemType = {
  COURSE: 'COURSE',
  EBOOK: 'EBOOK',
  SERVICE: 'SERVICE',
  SUBSCRIPTION: 'SUBSCRIPTION',
  DIGITAL_GOODS: 'DIGITAL_GOODS',
  OTHER: 'OTHER',
} as const;
